import { render } from "./monthNavigator.vue?vue&type=template&id=6faf5314&ts=true"
import script from "./monthNavigator.vue?vue&type=script&lang=ts"
export * from "./monthNavigator.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__